import { ReactNode, useEffect, useRef } from "react";

function ScrollToBottom({ children }: { children: ReactNode }) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const scrollToBottom = () => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    // Use MutationObserver to detect dynamic changes in the container:
    const mutationObserver = new MutationObserver(() => {
      scrollToBottom();
    });
    mutationObserver.observe(container, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // Optionally, you can also add a ResizeObserver to detect dimension changes.
    const resizeObserver = new ResizeObserver(() => {
      scrollToBottom();
    });
    resizeObserver.observe(container);

    // Clean up observers on unmount:
    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div ref={containerRef} className="overflow-y-scroll">
      {children}
      <div ref={messagesEndRef} id="chat-bottom" />
    </div>
  );
}

export default ScrollToBottom;
